import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { getAppURL } from '../../AppContext/selectors'
import searchIcon from './../../../assets/images/searchicon.png'

const InputGroup = styled.div`
    margin-right: 35px;
    border: 1px solid var(--sv-color-medium-gray);
    width: 100%;
    padding: 0 12px 0 16px;
    background: var(--sv-color-white);
    border-radius: 80px;
    height: 36px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    overflow: visible;
    box-sizing: border-box;
    transition: border-color 0.15s ease-in-out;
    &:focus-within {
        border-color: var(--sv-color-hyperlink-teal);
        box-shadow: 0 0 0 3px var(--sv-color-hyperlink-teal);
    }
`

const InputGroupAddon = styled.div`
    margin-right: -1px;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    align-items: center;
    justify-content: center;
    height: 36px;
    position: relative;
    z-index: 1;
    img {
        height: 16px;
        width: 16px;
        margin: 0;
    }
`

const Input = styled.input`
    border: 0px;
    border-radius: 80px;
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0;
    display: block;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: var(--sv-color-text-gray);
    background-color: transparent;
    background-clip: padding-box;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    outline: none;
    box-shadow: none;
    &:focus,
    &:focus-visible {
        outline: none;
        box-shadow: none;
    }
    overflow: visible;
    margin: 0;
    font-family: inherit;
    box-sizing: border-box;
`

const SearchBar = ({ className,translationKey,currentFileRequired }) => {
    const [input, setInput] = useState()
    const appURL = useSelector(getAppURL)
    
    const handleSubmit = e => {
        e.preventDefault()
        window.location.href = `${appURL}#/search/${encodeURIComponent(input)}`
    }
   
    return (
        <form className={className} onSubmit={handleSubmit}>
            <InputGroup>
                <InputGroupAddon addonType="prepend">
                    <img alt="Search icon" src={searchIcon} />
                </InputGroupAddon>
                <Input
                    type="search"
                    name="keywords"
                    placeholder={translationKey(currentFileRequired['SEARCH_CATALOG'])}
                    onChange={e => setInput(e.currentTarget.value)}
                />
            </InputGroup>
        </form>
    )
}

export default SearchBar
